/* ColagenPlus — JS comun (asset). Idempotent: se poate include de mai multe ori. */
(function () {
  if (window.__cpJsLoaded) return;
  window.__cpJsLoaded = true;

  /* --- CP · Recenzii Judge.me pe PDP (data-cp-jm): primele N rânduri, „Vezi mai multe” le arată pe toate.
     Judge.me randează asincron, deci butonul apare doar după ce există mai mult de N recenzii. --- */
  function cpJmCheck() {
    document.querySelectorAll('[data-cp-jm]').forEach(function (jm) {
      var btn = jm.parentElement.querySelector('[data-cp-jm-more]');
      if (!btn || jm.classList.contains('is-open')) return;
      var n = parseInt(jm.getAttribute('data-rows'), 10) || 5;
      btn.hidden = jm.querySelectorAll('.jdgm-rev').length <= n;
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cp-jm-more]');
    if (!b) return;
    var jm = b.parentElement.parentElement.querySelector('[data-cp-jm]');
    if (jm) jm.classList.add('is-open');
    b.hidden = true;
  });
  function cpJmInit() {
    cpJmCheck();
    if (!window.MutationObserver) return;
    var t;
    document.querySelectorAll('[data-cp-jm]').forEach(function (jm) {
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(cpJmCheck, 200); })
        .observe(jm, { childList: true, subtree: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', cpJmInit); else cpJmInit();

  /* --- CP · Slider produse (data-cp-msl): săgeți = derulare cu lățimea unui card; stare disabled la capete --- */
  function cpMslUpdate(root) {
    var t = root.querySelector('[data-cp-msl-track]');
    if (!t) return;
    var prev = root.querySelector('[data-cp-msl-dir="-1"]');
    var next = root.querySelector('[data-cp-msl-dir="1"]');
    var max = t.scrollWidth - t.clientWidth - 2;
    if (prev) prev.disabled = t.scrollLeft <= 2;
    if (next) next.disabled = t.scrollLeft >= max;
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cp-msl-dir]');
    if (!b) return;
    var root = b.closest('[data-cp-msl]');
    var t = root && root.querySelector('[data-cp-msl-track]');
    if (!t) return;
    var card = t.firstElementChild;
    var step = card ? card.getBoundingClientRect().width + 10 : 140;
    t.scrollBy({ left: step * parseInt(b.getAttribute('data-cp-msl-dir'), 10), behavior: 'smooth' });
  });
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-cp-msl-track]')) cpMslUpdate(t.closest('[data-cp-msl]'));
  }, true);
  function cpMslInit() { document.querySelectorAll('[data-cp-msl]').forEach(cpMslUpdate); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', cpMslInit); else cpMslInit();
  window.addEventListener('resize', cpMslInit);

  /* --- CP · Video slider: play/pauză la click, un singur video rulează odată.
     Slide YouTube (data-yt): la click se injectează playerul embed cu autoplay;
     deschiderea unuia restaurează thumbnail-urile celorlalte. --- */
  function cpResetYtSlides(except) {
    document.querySelectorAll('.cp-videos__slide[data-yt].playing').forEach(function (s) {
      if (s === except) return;
      var f = s.querySelector('iframe');
      if (f) f.remove();
      s.classList.remove('playing');
      var t = s.querySelector('.cp-videos__thumb');
      if (t) t.style.display = '';
      var p = s.querySelector('.cp-videos__play');
      if (p) p.style.opacity = '';
    });
  }

  document.addEventListener('click', function (e) {
    var slide = e.target.closest('.cp-videos__slide');
    if (!slide) return;

    var yt = slide.getAttribute('data-yt');
    if (yt) {
      if (slide.classList.contains('playing')) return;
      cpResetYtSlides(slide);
      document.querySelectorAll('.cp-videos__slide video').forEach(function (v) { v.pause(); });
      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube.com/embed/' + yt + '?autoplay=1&playsinline=1&rel=0';
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
      iframe.allowFullscreen = true;
      slide.appendChild(iframe);
      slide.classList.add('playing');
      var play = slide.querySelector('.cp-videos__play');
      if (play) play.style.opacity = '0';
      return;
    }

    var video = slide.querySelector('video');
    if (!video) return;
    cpResetYtSlides(null);
    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }
  });

  document.addEventListener(
    'play',
    function (e) {
      if (!(e.target instanceof HTMLVideoElement)) return;
      var slide = e.target.closest('.cp-videos__slide');
      if (slide) slide.classList.add('playing');
      document.querySelectorAll('.cp-videos__slide video').forEach(function (v) {
        if (v !== e.target) v.pause();
      });
    },
    true
  );

  document.addEventListener(
    'pause',
    function (e) {
      if (!(e.target instanceof HTMLVideoElement)) return;
      var slide = e.target.closest('.cp-videos__slide');
      if (slide) slide.classList.remove('playing');
    },
    true
  );

  /* --- CP · Modal (nutrițional etc.): data-cp-modal-open="#id" / data-cp-modal-close / overlay / Esc --- */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-cp-modal-open]');
    if (opener) {
      var modal = document.querySelector(opener.getAttribute('data-cp-modal-open'));
      if (modal) modal.classList.add('open');
      return;
    }
    var closer = e.target.closest('[data-cp-modal-close]');
    if (closer) {
      var m = closer.closest('.cp-modal');
      if (m) m.classList.remove('open');
      return;
    }
    if (e.target.classList && e.target.classList.contains('cp-modal')) {
      e.target.classList.remove('open');
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.cp-modal.open').forEach(function (m) {
        m.classList.remove('open');
      });
    }
  });

  /* --- CP · Carduri produs: săgeți slider + ascundere când nu e overflow --- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cp-pnav]');
    if (!btn) return;
    var track = btn.closest('.cp-pcards-wrap').querySelector('.cp-pcards');
    if (!track) return;
    var card = track.querySelector('.cp-pcards__card');
    var step = card ? card.getBoundingClientRect().width + 22 : track.clientWidth / 2;
    track.scrollBy({ left: btn.getAttribute('data-cp-pnav') === 'next' ? step : -step, behavior: 'smooth' });
  });

  function cpPcardsOverflow() {
    document.querySelectorAll('.cp-pcards-wrap').forEach(function (w) {
      var t = w.querySelector('.cp-pcards');
      if (t) w.classList.toggle('no-overflow', t.scrollWidth <= t.clientWidth + 4);
    });
  }
  window.addEventListener('resize', cpPcardsOverflow);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cpPcardsOverflow);
  } else {
    cpPcardsOverflow();
  }

  /* --- CP · Scroll lin către un element (ex. CTA final → selectorul de pachete) --- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cp-scroll]');
    if (!btn) return;
    var target = document.querySelector(btn.getAttribute('data-cp-scroll'));
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
})();
